module.exports = __webpack_public_path__ + "static/masjid-cover-c714d1ab3da27e4e8d24db6f1f63818a.jpg";